import { Phone, MapPin, Clock } from "lucide-react";
import { BUSINESS } from "../data/business";
import { SectionHeading } from "../components/SectionHeading";
import { Reveal } from "../components/Reveal";
import { ContactForm } from "../components/Forms";
import { MapSection } from "../components/MapSection";
import { useSEO } from "../hooks/useSEO";

export default function Contact() {
  useSEO(
    "Contact | New Lookz Hair Salon — Gandhi Nagar, Hyderabad",
    "Contact New Lookz Hair Salon in New Bakaram, Gandhi Nagar, Hyderabad. Call +91 88863 93777 or send an enquiry.",
    "/contact"
  );

  const info = [
    { icon: Phone, label: "Phone", value: BUSINESS.phoneDisplay, href: BUSINESS.phoneHref, testId: "contact-phone" },
    { icon: MapPin, label: "Address", value: BUSINESS.addressFull, testId: "contact-address" },
    { icon: Clock, label: "Opening Hours", value: BUSINESS.hours.length ? BUSINESS.hours.map((h) => `${h.days}: ${h.time}`).join(" · ") : BUSINESS.hoursNote, testId: "contact-hours" },
  ];

  return (
    <>
      <section className="bg-ink grain" data-testid="contact-hero">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
          <SectionHeading
            dark
            eyebrow="Contact"
            title="Talk to the Salon"
            text="Call, visit, or send an enquiry — we reply as soon as we can."
          />
          <div className="mt-12 grid sm:grid-cols-3 gap-5">
            {info.map((it, i) => (
              <Reveal key={it.label} delay={i * 0.08} className="h-full">
                <div className="h-full rounded-xl bg-coal border border-white/10 p-6" data-testid={it.testId}>
                  <it.icon size={18} className="text-copper mb-4" aria-hidden="true" />
                  <p className="text-xs font-semibold tracking-[0.2em] uppercase text-white/45">{it.label}</p>
                  {it.href ? (
                    <a href={it.href} className="block mt-2 font-display font-bold text-white hover:text-copper transition-colors">{it.value}</a>
                  ) : (
                    <p className="mt-2 text-white/75 text-sm leading-relaxed">{it.value}</p>
                  )}
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-ivory" data-testid="contact-form-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 grid lg:grid-cols-2 gap-12">
          <div>
            <SectionHeading
              eyebrow="Send an Enquiry"
              title="We’ll Get Back to You"
              text="Questions about services, availability or anything else — drop a message and the salon will respond."
            />
            <Reveal delay={0.1}>
              <div className="mt-8 rounded-xl bg-paper border border-ink/10 p-6 sm:p-8 shadow-[0_20px_50px_-25px_rgba(17,17,17,0.3)]">
                <ContactForm />
              </div>
            </Reveal>
          </div>
          <Reveal delay={0.15} className="lg:pt-24">
            <div className="rounded-xl overflow-hidden border border-ink/10 h-full min-h-[320px]">
              <iframe
                src={BUSINESS.mapsEmbedUrl}
                title="Map — New Lookz Hair Salon"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="w-full h-full min-h-[320px] grayscale-[35%]"
                data-testid="contact-map"
              />
            </div>
          </Reveal>
        </div>
      </section>

      <MapSection dark />
    </>
  );
}
